import { OfferType } from '../domain/OfferType'

export function formatOfferType(offerType: OfferType): string {
  switch (offerType) {
    case OfferType.Instant:
      return 'Instant'
    case OfferType.Contracted:
      return 'Contracted'
    case OfferType.ShipperDirect:
      return 'ShipperDirect'
  }
}
